import { EnumWithDescription, ICustomEnumValue } from "../EnumWithDescription";

export enum HosCodeStatusEnum {
    DoNotResuscitate = 1,
    DoNotHospitalize = 2,
    DoNotIntubate = 4
}

export class HosCodeStatusEnumClass extends EnumWithDescription<HosCodeStatusEnum> {
    public readonly enum = HosCodeStatusEnum;
    public readonly enumName: string = "HosCodeStatus";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HosCodeStatusEnum>> = new Map([
        [
            "Do Not Resuscitate",
            {
                value: HosCodeStatusEnum.DoNotResuscitate,
                name: "DoNotResuscitate"
            }
        ],
        [
            "Do Not Hospitalize",
            {
                value: HosCodeStatusEnum.DoNotHospitalize,
                name: "DoNotHospitalize"
            }
        ],
        [
            "Do Not Intubate",
            {
                value: HosCodeStatusEnum.DoNotIntubate,
                name: "DoNotIntubate"
            }
        ]
    ]);
}

export const HosCodeStatus = new HosCodeStatusEnumClass();
